import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {routing} from './auth.routing';

import {AuthService} from './auth.service';
import {CheckAuthService} from './check-auth.service';
import {AuthCheckComponent} from './auth-check/auth-check.component';
import {LoadingComponent} from './loading/loading.component';
import {CommonModule} from '@angular/common';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpLoaderFactory} from '../app.module';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {LogoutComponent} from './logout/logout.component';
import {TokenInterceptor} from './interceptors/token.interceptor';
import {AuthRefreshService} from './auth-refresh.service';
import {AUTH_REFRESH_SERVICE} from './auth-refresh-service.token';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    LoginComponent, AuthCheckComponent, LoadingComponent, LogoutComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },

    AuthService, CheckAuthService, AuthRefreshService,
    {provide: AUTH_REFRESH_SERVICE, useExisting: AuthRefreshService}
  ]
})
export class AuthenticationModule {
  constructor() {
    console.log('loaded auth module');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts